<template>
  <div v-show="detailShow" class="detail">
     <Modal v-model="editTypeModal" title="编辑问题分类" @on-cancel="cancelEditTypeModal">
      <Form :model="editTypeForm" :label-width="60">
        <FormItem label="问题大类" prop="type">
          <Select v-model="editTypeForm.type" @on-change="handleTypeOnChange" placeholder="请选择指派目标问题大类">
            <Option v-for="item in workSheetTypeList" :key="item.id" :value="item.id" :label="item.type_name"></Option>
          </Select>
        </FormItem>
        <FormItem label="问题子类" prop="sonType">
          <Select v-model="editTypeForm.sonType" placeholder="请选择指派目标问题子类">
            <Option v-for="item in workSheetSonTypeList" :key="item.id" :value="item.id" :label="item.type_name"></Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="editTypeOK">提交</Button>
      </div>
    </Modal>
    <Modal v-model="editDeadlineModal" title="编辑截止日期" @on-cancel="cancelEditDeadlineModal">
      <Form :model="editDeadlineForm" :label-width="70" ref="editDeadlineForm" :rules="validRule">
        <FormItem label="截止日期" prop="deadline">
          <DatePicker v-model="editDeadlineForm.deadline"  type="date" style="width:100%;" format="yyyy-MM-dd"></DatePicker>
        </FormItem>
        <FormItem label="回复" prop="message">
          <Input type="textarea" v-model="editDeadlineForm.message" placeholder="回复提交人（可选）" />
      </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="editDeadlineOK">提交</Button>
      </div>
    </Modal>
    <Modal v-model="editEmailModal" @on-cancel="cancelEditEmailModal">
       <p slot="header" style="color:#f60;">
            <Icon type="ios-information-circle"></Icon>
            <span>编辑审批人邮箱(更改后工单自动打回到待审批状态)</span>
        </p>
      <Form :model="editEmailForm" :label-width="85"  ref="editEmailForm" :rules="validEmail">
        <FormItem label="审批人邮箱" prop="email">
           <Input v-model="editEmailForm.email" placeholder="如有多个, 请用英文分号 ; 分隔 , 最多10个邮箱 ！" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="error" @click="editEmailOK">提交</Button>
      </div>
    </Modal>
    <Modal v-model="editCcEmailModal" title="编辑抄送人邮箱" @on-cancel="cancelEditCcEmailModal">
      <Form :model="editCcEmailForm" :label-width="85" ref="editCcEmailForm" :rules="validCcEmail">
        <FormItem label="抄送人邮箱" prop="cc_email">
           <Input v-model="editCcEmailForm.cc_email" placeholder="如有多个, 请用英文分号 ; 分隔 , 最多10个邮箱 ！" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="editCcEmailOK">提交</Button>
      </div>
    </Modal>
    <div class="content">
      <div class="main" style="padding-top: 0">
        <div>
          <Row class="title">
            <h4 style="float: left; margin: 0">详细信息</h4>
            <div style="float: right">
              <a href="#" @click.prevent="enlarge" v-show="enlargeShow">
                <Icon type="md-contract" size="20" />
              </a>
              <a href="#" @click.prevent="narrow" v-show="!enlargeShow">
                <Icon type="md-contract" size="20" />
              </a>
              <a href="#" @click.prevent="close" style="margin-left: 5px">
                <Icon type="md-close-circle" size="20" />
              </a>
            </div>
          </Row>
          <div class="info-property">
            <dl>
              <dt>工单编号</dt><dd>{{ info.wsid }}</dd>
            </dl>
            <dl>
              <dt>标题</dt><dd>{{ info.title }}</dd>
            </dl>
            <dl v-if="info.source === '网页'">
              <dt>问题描述</dt><dd><span v-html="info.description.replace(/\n\n/g, '<br>').replace(/\n/g, '<br>')"></span></dd>
            </dl>
            <dl v-if="info.source === '网页'">
              <dt>图片</dt>
              <dd>
                <div class="demo-upload-list" v-for="(item, index) in img_list" :key="index">
                  <template>
                    <viewer :images="[baseApiUrl + item.url]">
                      <img :src="baseApiUrl + item.url">
                    </viewer>
                  </template>
                </div>
              </dd>
            </dl>
            <dl v-if="info.source === '网页'">
              <dt>附件</dt>
              <dd>
                <ul style="text-align:left">
                  <li class="title" style="white-space: pre-wrap;word-wrap: break-word;" v-for="(item, index) in file_list" :key="index">
                    <!--<span>{{ item.filename }} （上传时间：{{ moment(item.date).format('YYYY-MM-DD HH:mm:ss') }}）</span>-->
                    <span>{{ item.filename }} </span>
                    <a :href="baseApiUrl+item.url" download>下载附件</a>
                  </li>
                </ul>
              </dd>
            </dl>
            <dl>
              <dt>来源</dt><dd>{{ info.source }}</dd>
            </dl>
            <dl>
              <dt>大类</dt><dd><span v-if="info.type">{{ info.type.type_name }}</span>
              <Button type="warning" size="small" @click="openTypeModal">编辑</Button></dd>
            </dl>
            <dl>
              <dt>子类</dt><dd><span v-if="info.son_type">{{ info.son_type ? info.son_type.type_name : '' }}</span>
               </dd>
            </dl>
            <dl v-if="info.s_time">
               <dt style="color:red">权限开始时间</dt><dd style="color:red">{{ info.s_time.replace(/T/gi, ' ').replace(/Z/gi, '').replace(':00:00', '') + '时' }}</dd>
            </dl>
            <dl v-if="info.e_time">
              <dt style="color:red">权限终止时间</dt><dd style="color:red;font-weight:bold;">{{ info.e_time.replace(/T/gi, ' ').replace(/Z/gi, '').replace(':00:00', '') + '时' }}</dd>
            </dl>
            <dl>
              <dt>提交人</dt><dd>{{ info.submitter }}</dd>
            </dl>
            <dl>
              <dt>提交人邮箱</dt><dd>{{ info.submitter_email }}</dd>
            </dl>
           <dl>
              <dt>提交人上级</dt><dd>{{ info.submitter_manager }}</dd>
            </dl>
            <dl>
              <dt>提交人部门</dt><dd>{{ info.submitter_dep }}</dd>
            </dl>
            <dl>
              <dt>提交时间</dt><dd v-if="info.c_time">{{ moment(info.c_time).format('YYYY-MM-DD HH:mm:ss') }}</dd>
            </dl>
            <dl>
              <dt>状态</dt><dd v-if="info.status || info.status === 0">{{ typeTran[info.status] }}</dd>
            </dl>
            <dl>
              <dt>审批人邮箱</dt><dd><span>{{ info.email }}</span>
              <Button type="warning" size="small" @click="openEmailModal">编辑</Button></dd>
            </dl>
            <dl>
              <dt>抄送人邮箱</dt><dd><span>{{ info.cc_email }}</span>
              <Button type="warning" size="small" @click="openCcEmailModal">编辑</Button></dd>
            </dl>
            <dl>
              <dt>受理人</dt>
              <dd>
                <span v-if="info.receive_people">
                  <span v-if="info.receive_people.name">{{ info.receive_people.name }}</span>
                  <span v-else>{{ info.receive_people.username }}</span>
                </span>
              </dd>
            </dl>
            <dl>
              <dt>受理时间</dt><dd v-if="info.a_time">{{ moment(info.a_time).format('YYYY-MM-DD HH:mm:ss') }}</dd>
            </dl>
            <dl>
              <dt>截止时间</dt><dd v-if="info.deadline">{{ moment(info.deadline).format('YYYY-MM-DD') }}
                <Button type="warning" size="small" @click="openDeadlineModal">编辑</Button>
              </dd>
            </dl>
            <dl>
              <dt>处理人</dt>
              <dd>
                <span v-if="info.operator">
                  <span v-if="info.operator.name">{{ info.operator.name }}</span>
                  <span v-else>{{ info.operator.username }}</span>
                </span>
              </dd>
            </dl>
            <dl>
              <dt>处理时间</dt><dd v-if="info.f_time">{{ moment(info.f_time).format('YYYY-MM-DD HH:mm:ss') }}</dd>
            </dl>
            <dl>
              <dt>结果</dt><dd v-if="info.result">{{ resultTran[info.result] }}</dd>
            </dl>
            <dl>
              <dt>评价</dt><dd v-if="info.rate"><Rate disabled v-model="info.rate"/></dd>
            </dl>
          </div>
        </div>
        <div>
          <Row class="title">
            <h4>操作记录</h4>
          </Row>
          <div class="info-property">
            <dl v-for="(item, index) in operate_logs_list" :key="index">
              <dt>{{ moment(item.datetime).format('YYYY-MM-DD HH:mm:ss') }}</dt><dd>{{ item.user_name }} {{ item.content }}</dd>
            </dl>
          </div>
        </div>
        <div>
          <Row class="title">
            <h4>沟通记录</h4>
          </Row>
          <div class="info-property">
            <dl v-for="(item, index) in communicate_list" :key="index">
              <dt>{{ moment(item.datetime).format('YYYY-MM-DD HH:mm:ss') }}</dt>
              <dd>
                <span v-if="item.user_type === 0">用户</span>
                <span v-else>{{ item.user }}</span>
                <span v-if="item.type === 1"> 反馈：</span>
                <span v-else> 回复：</span>
                <!-- <span>{{ item.content }} </span> -->
                <span v-html="item.content"></span>
                <!-- <div class="demo-upload-list" v-for="(url, index) in item.file_urls" :key="index">
                  <template>
                    <viewer :images="[baseApiUrl + url]">
                      <img :src="baseApiUrl + url">
                    </viewer>>
                  </template>
                </div> -->
              </dd>
            </dl>
          </div>
        </div>
        <div v-if="info.status !== 0 && info.status !== 3 && info.source === '网页'">
          <Row class="title">
            <h4>我要回复</h4>
          </Row>
          <!-- 上传图片 -->
            <!-- <Upload
                multiple
                :show-upload-list="false"
                :max-size="10240"
                :on-exceeded-size="maxSize"
                :on-success="handleImageSuccess"
                :format="['jpg','jpeg','png']"
                :on-format-error="imageFormatError"
                :before-upload="showLoading"
                :action="logisticsUploadImgUrlChat"
                class="uploadImage ">
            </Upload> -->
             <!-- <quill-editor v-model="comm" ref="myQuillEditor" :options="editorOption"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
              @ready="onEditorReady($event)">
            </quill-editor> -->
            <vue-editor v-model="comm" ref="myQuillEditor" useCustomImageHandler  @imageAdded="handleImageAdded" :editorOptions="editorOption"></vue-editor>
          <!-- <Input type="textarea" v-model="comm" :rows="5" placeholder="填写回复内容"/> -->
          <Button type="primary" @click="commOk" :loading="serviceComming" :style="{marginTop: '5px'}">提交回复</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { detailWorkSheet, GetOperateLogsApi, GetCommunicateApi, GetFileListApi,
  ServiceCommApi, logisticsUploadImgUrlChat, editTypeApi, editSonTypeApi, editDeadlineApi, editCcEmailApi, editEmailApi } from '@/api/logistics/worksheet'
import { GetALLWorkSheetType, GetALLWorkSheetTypeSon } from '@/api/logistics/type'
import moment from 'moment'
import eventVue from './event.js'
import config from '@/config'
import dayjs from 'dayjs'
import axios from 'axios'

// quill editor
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// import { quillEditor, Quill } from 'vue-quill-editor'
import { VueEditor, Quill } from 'vue2-editor'
import { ImageDropAndPaste } from './QuillImageDropAndPaste.js'
// import { ImageDropAndPaste } from 'quill-image-drop-and-paste'
import { base64StringToBlob } from 'blob-util'

Quill.register('modules/imageDropAndPaste', ImageDropAndPaste)

var Image = Quill.import('formats/image')
Image.className = 'Image'
Quill.register(Image, true)

var Link = Quill.import('formats/link')
class FileBlot extends Link {
  static create (value) {
    let node = null
    if (value && !value.href) {
      node = super.create(value)
    } else {
      node = super.create(value.href)
      // node.setAttribute('download', true)  // 左键点击即下载
      // node.setAttribute('download', value.innerText);  // 左键点击即下载
      node.innerText = value.innerText
      // node.download = value.innerText
    }
    return node
  }
}
FileBlot.blotName = 'link'
FileBlot.tagName = 'A'
Quill.register(FileBlot)

export default {
  name: 'detail',
  components: { VueEditor },
  data () {
    return {
      editTypeModal: false,
      editSonTypeModal: false,
      editDeadlineModal: false,
      editEmailModal: false,
      editCcEmailModal: false,
      editTypeForm: {
        id: '',
        type: '',
        sonType: ''
      },
      editSonTypeForm: {
        id: '',
        sonType: ''
      },
      editDeadlineForm: {
        id: '',
        deadline: '',
        message: ''
      },
      editEmailForm: {
        id: '',
        email: ''
      },
      editCcEmailForm: {
        id: '',
        cc_email: ''
      },
      workSheetTypeList: [],
      workSheetSonTypeList: [],
      fileLoading: false,
      logisticsUploadImgUrlChat: logisticsUploadImgUrlChat,
      editorOption: {
        modules: {
          toolbar: {
            container: [
              ['image']
            ]
          },
          imageDropAndPaste: {
            handler: this.imageHandler
          }
        }
      },
      detailShow: false,
      baseApiUrl: config.workSheetApi + '/worksheet',
      info: {},
      typeTran: {
        0: '关闭',
        1: '未受理',
        2: '处理中',
        3: '已处理',
        4: '待审批'
      },
      resultTran: {
        1: '用户反馈：已解决',
        2: '用户反馈：未解决',
        3: '自动关闭',
        4: '客服关闭'
      },
      moment: moment,
      enlargeShow: true,
      id: '',
      operate_logs_list: [],
      communicate_list: [],
      img_list: [],
      file_list: [],
      comm: '',
      serviceComming: false,
      validRule: {
        deadline: { required: true, type: 'date', message: '请选择截止时间', trigger: 'change' }
      },
      validEmail: {
        email: { required: true, message: '审批人邮箱不能为空', trigger: 'blur' }
      },
      validCcEmail: {
        cc_email: { required: true, message: '抄送人邮箱不能为空', trigger: 'blur' }
      }
    }
  },
  created: function () {
    this.getWorkSheetAllTypeList()
  },
  methods: {
    imageHandler (imageDataUrl, type) {
      // console.log(imageDataUrl)
      // console.log(type)
      // give a default mime type if the type was null
      if (!type) type = 'image/png'
      // base64 to blob
      var blob = base64StringToBlob(imageDataUrl.replace(/^data:image\/\w+;base64,/, ''), type)
      var filename = ['image', '-', new Date().getTime()].join('')
      // generate a form data
      var formData = new FormData()
      formData.append('filename', filename)
      formData.append('file', blob)
      // upload image to your server
      axios({
        url: logisticsUploadImgUrlChat,
        method: 'POST',
        data: formData
      })
        .then(res => {
          this.handleImageSuccess(res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
      console.log(file)
      let formData = new FormData()
      let filename = ['image', '-', new Date().getTime()].join('')
      formData.append('file', file)
      formData.append('filename', filename)
      axios({
        url: logisticsUploadImgUrlChat,
        method: 'POST',
        data: formData
      })
        .then(res => {
          this.handleImageSuccess(res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    openTypeModal () {
      console.log(this.info.type)
      this.editTypeForm.type = this.info.type ? this.info.type.id : null
      this.editTypeForm.sonType = this.info.son_type ? this.info.son_type.id : null
      this.editTypeModal = true
    },
    openSonTypeModal () {
      console.log(this.info.son_type)
      this.editSonTypeForm.sonType = this.info.son_type ? this.info.son_type.id : null
      this.editSonTypeModal = true
    },
    openDeadlineModal () {
      this.editDeadlineModal = true
      this.editDeadlineForm.deadline = this.info.deadline === null ? null : new Date(this.info.deadline)
    },
    openEmailModal () {
      this.editEmailForm.email = this.info.email
      this.editEmailModal = true
    },
    openCcEmailModal () {
      this.editCcEmailForm.cc_email = this.info.cc_email
      this.editCcEmailModal = true
    },
    getWorkSheetAllTypeList () {
      GetALLWorkSheetType().then(res => {
        this.workSheetTypeList = res.data
      })
    },
    init (id) {
      if (!id) {
        this.$Notice.error({
          title: '此工单不存在'
        })
        return false
      }
      this.empty()
      this.detailShow = true
      this.id = id
      this.getInfo(id)
      this.getOperateLogs(id)
      this.getCommunicate(id)
      this.getFileList(id)
    },
    empty () {
      this.info = {}
      this.id = ''
      this.comm = ''
      this.operate_logs_list = []
      this.communicate_list = []
      this.img_list = []
      this.file_list = []
    },
    getInfo (id) {
      detailWorkSheet(id).then(res => {
        this.info = res.data
        if (this.info.type) {
          this.getWorkSheetAllTypeListSon(this.info.type.id)
        }
      }).catch(_ => {
        this.$Notice.error({
          title: '获取工单详情信息失败，请重试'
        })
      })
    },
    getWorkSheetAllTypeListSon (typeId) {
      let params = {
        parent_id: typeId
      }
      GetALLWorkSheetTypeSon(params).then(res => {
        this.workSheetSonTypeList = res.data
      })
    },
    getOperateLogs (id) {
      if (!id) {
        this.$Notice.error({
          title: '获取工单操作记录失败，此工单不存在'
        })
        return false
      } else {
        GetOperateLogsApi({ worksheet: id }).then(res => {
          this.operate_logs_list = res.data
        })
      }
    },
    getCommunicate (id) {
      if (!id) {
        this.$Notice.error({
          title: '获取工单沟通记录失败，此工单不存在'
        })
      } else {
        GetCommunicateApi({ worksheet: id }).then(res => {
          this.communicate_list = res.data
        })
      }
    },
    getFileList (id) {
      this.img_list = []
      this.file_list = []
      if (!id) {
        this.$Notice.error({
          title: '获取工单图片和附件失败，此工单不存在'
        })
      } else {
        GetFileListApi({ worksheet: id }).then(res => {
          let result = res.data
          for (let i in result) {
            if (result[i].file_type === 0) {
              this.img_list.push(result[i])
            } else {
              this.file_list.push(result[i])
            }
          }
        })
      }
    },
    enlarge () {
      eventVue.$emit('enlargeFun', true)
      this.enlargeShow = false
    },
    narrow () {
      eventVue.$emit('narrowFun', true)
      this.enlargeShow = true
    },
    close () {
      eventVue.$emit('closeFun', true)
    },
    cancelEditTypeModal () {
      this.editTypeForm.id = ''
      this.editTypeForm.type = ''
      this.editTypeForm.sonType = ''
    },
    cancelEditSonTypeModal () {
      this.editSonTypeForm.id = ''
      this.editSonTypeForm.sonType = ''
    },
    cancelEditDeadlineModal () {
      this.editDeadlineForm.id = ''
      this.editDeadlineForm.deadline = ''
      this.editDeadlineForm.message = ''
    },
    cancelEditEmailModal () {
      this.editEmailForm.id = ''
      this.editEmailForm.type = ''
    },
    cancelEditCcEmailModal () {
      this.editCcEmailForm.id = ''
      this.editCcEmailForm.type = ''
    },
    handleTypeOnChange (typeId) {
      this.editTypeForm.sonType = ''
      // 取当前大类的子类
      if (typeId) {
        this.getWorkSheetAllTypeListSon(typeId)
      }
    },
    editTypeOK () {
      this.editTypeForm.id = this.id
      editTypeApi(this.editTypeForm).then(res => {
        const result = res.data
        if (result.code === 200) {
          this.$Notice.success({
            title: '操作成功！'
          })
          this.getInfo(this.id)
          this.$emit('on-result-change')
          this.editTypeModal = false
        } else {
          this.$Notice.error({
            title: '操作失败',
            desc: result.msg
          })
        }
      }).catch(_ => {
      })
    },
    editSonTypeOK () {
      this.editSonTypeForm.id = this.id
      editSonTypeApi(this.editSonTypeForm).then(res => {
        const result = res.data
        if (result.code === 200) {
          this.$Notice.success({
            title: '操作成功！'
          })
          this.getInfo(this.id)
          this.$emit('on-result-change')
          this.editSonTypeModal = false
        } else {
          this.$Notice.error({
            title: '操作失败',
            desc: result.msg
          })
        }
      }).catch(_ => {
      })
    },
    editDeadlineOK () {
      this.$refs['editDeadlineForm'].validate((valid) => {
        console.log(valid)
        if (valid) {
          this.editDeadlineForm.id = this.id
          this.editDeadlineForm.deadline = this.editDeadlineForm.deadline === '' ? '' : dayjs(this.editDeadlineForm.deadline).format('YYYY-MM-DD')
          let data = JSON.parse(JSON.stringify(this.editDeadlineForm))
          editDeadlineApi(data).then(res => {
            const result = res.data
            if (result.code === 200) {
              this.$Notice.success({
                title: '操作成功！'
              })
              this.getInfo(this.id)
              this.editDeadlineModal = false
            } else {
              this.$Notice.error({
                title: '操作失败',
                desc: result.msg
              })
            }
          }).catch(_ => {
          })
        }
      })
    },
    editEmailOK () {
      this.$refs['editEmailForm'].validate((valid) => {
        console.log(valid)
        if (valid) {
          this.editEmailForm.id = this.id
          editEmailApi(this.editEmailForm).then(res => {
            const result = res.data
            if (result.code === 200) {
              this.$Notice.success({
                title: '操作成功！'
              })
              this.getInfo(this.id)
              this.$emit('on-result-change')
              this.editEmailModal = false
            } else {
              this.$Notice.error({
                title: '操作失败',
                desc: result.msg
              })
            }
          }).catch(_ => {
          })
        }
      })
    },
    editCcEmailOK () {
      this.$refs['editCcEmailForm'].validate((valid) => {
        console.log(valid)
        if (valid) {
          this.editCcEmailForm.id = this.id
          editCcEmailApi(this.editCcEmailForm).then(res => {
            const result = res.data
            if (result.code === 200) {
              this.$Notice.success({
                title: '操作成功！'
              })
              this.getInfo(this.id)
              this.editCcEmailModal = false
            } else {
              this.$Notice.error({
                title: '操作失败',
                desc: result.msg
              })
            }
          }).catch(_ => {
          })
        }
      })
    },
    commOk () {
      // console.log(this.comm)
      this.comm = this.comm.replace('<img class="Image" src="//:0">', '')
      if (!this.comm) {
        this.$Notice.error({
          title: '回复内容不能为空'
        })
      } else {
        const reqData = {
          id: this.id,
          comm: this.comm
        }
        this.serviceComming = true
        ServiceCommApi(reqData).then(res => {
          let result = res.data
          if (result.code === 200) {
            this.getCommunicate(this.id)
            this.comm = ''
            this.serviceComming = false
          } else {
            this.serviceComming = false
            this.$Notice.error({
              title: result.msg
            })
          }
        }).catch(_ => {
          this.serviceComming = false
        })
      }
    },
    showLoading () {
      this.fileLoading = true
    },
    onEditorBlur (editor) {
      // console.log('editor blur!', editor)
    },
    onEditorFocus (editor) {
      // console.log('editor focus!', editor)
    },
    onEditorReady (editor) {
      // console.log('editor ready!', editor)
    },
    imageFormatError () {
      this.$Notice.warning({ title: '只支持 jpg、jpeg、png 格式' })
      this.fileLoading = false
    },
    maxSize () {
      this.$Notice.warning({ title: '文件太大, 限制最大10M' })
      this.fileLoading = false
    },
    // 图片
    handleImageSuccess (res) {
      // console.log(res)
      this.fileLoading = false
      let quill = this.$refs.myQuillEditor.quill
      let Delta = Quill.import('delta')
      let length = quill.getSelection().index
      let smallUrl = config.workSheetApi + res.data.data.url[0]
      let largeUrl = config.workSheetApi + res.data.data.url[1]
      quill.updateContents(new Delta().retain(length).insert(
        {
          image: smallUrl
        },
        {
          link: largeUrl
        }
      ))
      let newLength = quill.getSelection().index
      quill.setSelection(newLength + 1)
      // 针对粘贴图片里面多余的东西替换掉
      let delta = quill.getContents()
      console.log(delta)
      if ('ops' in delta && delta['ops'].length > 0) {
        delta['ops'] = delta['ops'].filter(item => typeof (item['insert']) === 'string' || (typeof (item['insert']) === 'object' && item['insert']['image'] !== '//:0'))
      }
      quill.setContents(delta)
      console.log(delta)
    }
    // handleImageSuccess (res, file) {
    //   this.fileLoading = false
    //   let quill = this.$refs.myQuillEditor.quill
    //   let Delta = Quill.import('delta')
    //   let length = quill.getSelection().index
    //   let smallUrl = config.workSheetApi + res.data.url[0]
    //   let largeUrl = config.workSheetApi + res.data.url[1]
    //   quill.updateContents(new Delta().retain(length).insert(
    //     {
    //       image: smallUrl
    //     },
    //     {
    //       link: largeUrl
    //     }
    //   ))
    //   let newLength = quill.getSelection().index
    //   quill.setSelection(newLength + 1)
    // },
    // newline (event) {
    //   let quill = this.$refs.myQuillEditor.quill
    //   // let delta = quill.getContents()
    //   let Delta = Quill.import('delta')
    //   let length = quill.getSelection().index
    //   quill.updateContents(new Delta().retain(length).insert('\n'))
    //   let newLength = quill.getSelection().index
    //   quill.setSelection(newLength + 1)
    // }
  }
}
</script>

<style lang="less">
  @import './base.less';
  .demo-upload-list{
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .demo-upload-list img{
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover{
    display: block;
  }
  .demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
  ul li {
    list-style: none;
  }
  pre{
    background-color: #fff;
    border:0;
    padding: 0;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .uploadImage{
    width: 0;
    height: 0;
    display: none;
   }
</style>

<style>
@media screen and (max-width:768px){
  .ivu-col-span-24 .detail .content .main{
    padding: 10px 0px;
  }
  .detail .ivu-icon-md-contract{
    display: none;
  }
}
</style>
